import React, { useContext } from "react";
import { ApplicationFlows } from "../../../route/application/authenticated/application-flow/types";
import {
  BasicAccountApplicationDocument,
  CardApplicationDocument,
} from "../../../api/commercial/generated-types";
import { useMessageSource } from "react-message-source";
import { CustomizationCardService } from "./customization-card-service";
import FlowHeader from "../../../ui/widgets/flow-header";
import ProductImage from "../../shared/components/product-image";
import { usePageTitle } from "../../shared/hooks/usePageTitle";
import { ProductRefType } from "../../../context/product-context/types";
import NavigationBar from "../../../ui/layout/page/content/footer/navigation-bar";
import ApplicationAPI from "../../../api/commercial/application";
import { ErrorContext } from "../../../route/error/provider";
import ApplicationPageContent from "../../../ui/layout/page/content/application";
import { ProductContext } from "../../../context/product-context/productContext";

export interface CustomizationCardAdapterProps {
  flowType: ApplicationFlows;
  basicAccountApplication: BasicAccountApplicationDocument;
  cardApplication: CardApplicationDocument;
  triggerReload: () => void;
}

export const CustomizationCardAdapter = ({
  flowType,
  basicAccountApplication,
  cardApplication,
  triggerReload,
}: CustomizationCardAdapterProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { setError } = useContext(ErrorContext);
  const { selectedProduct } = useContext(ProductContext);

  const onNext = async (): Promise<void> => {
    try {
      await ApplicationAPI.completeCardApplication(
        cardApplication.applicationRef,
        selectedProduct.productRef,
      );
    } catch (e) {
      setError(e);
    }
    triggerReload();
  };

  return (
    <>
      <FlowHeader
        image={
          <ProductImage
            product={basicAccountApplication.productRef as ProductRefType}
          />
        }
        title={usePageTitle(flowType)}
        subTitle={basicAccountApplication.company.name}
      />
      <ApplicationPageContent>
        <CustomizationCardService
          basicAccountApplication={basicAccountApplication}
        />
        <NavigationBar
          isSubmitting={false}
          onNext={onNext}
          nextButtonText={getMessage("Onboarding.continue")}
        />
      </ApplicationPageContent>
    </>
  );
};
